
import React from 'react'

import { useState, useEffect, useCallback } from 'react'

import './index.less'

export default function HocDragAndDrop(props) {
  const [ifon, setIfon] = useState({
    isPress: false,
    isMove: false,
    pressX: null,
    pressY: null,
    moveX: null,
    moveY: null,
    moveX1: null,
    moveY1: null,
    x1: null,
    x2: null,
    dom: React.createRef()
  })

  const move = useCallback((event) => {
    if (ifon.isPress && props.isCut && props.copyComp) {
      handleMove(event, ifon, setIfon)
      props.move && props.move({
        moveX: event.clientX,
        moveY: event.clientY,
        ifon: props.ifon
      })
    }
  })

  const up = useCallback((event) => {
    if (ifon.isPress && props.isCut) {
      handleUp(event, ifon, setIfon)
      props.up && props.up({
        upX: event.clientX,
        upY: event.clientY,
        ifon: props.ifon
      })
    } else if (ifon.isPress) {
      handleUp(event, ifon, setIfon)
      props.up && props.up({
        upX: event.clientX,
        upY: event.clientY,
        ifon: props.ifon
      })
    }
  })

  useEffect(() => {
    window.addEventListener('mousemove', move)
    window.addEventListener('mouseup', up)
    return () => {
      window.removeEventListener('mousemove', move)
      window.removeEventListener('mouseup', up)
    }
  })

  return (<div className='hocDragAndDrop' ref={ifon.dom} onMouseDown={
    (event) => {
      if (props.isCut) {
        handleDown(event, ifon, setIfon)
        props.pressAndHold && props.pressAndHold({
          pressX: event.clientX,
          pressY: event.clientY,
          ifon: props.ifon
        })
      } else {
        handleDown(event, ifon, setIfon)
        props.pressAndHold && props.pressAndHold({
          pressX: event.clientX,
          pressY: event.clientY,
          ifon: props.ifon
        })
      }
    }
  } >
    {props.children}
    {(props.copyComp && ifon.isPress && ifon.isMove) && <div className='hocDragAndDrop_copy' style={{
      left: (ifon.moveX1 - ifon.x1) + 'px',
      top: (ifon.moveY1 - ifon.y1) + 'px'
    }}><props.copyComp isCut={props.isCut} ifon={props.ifon}></props.copyComp></div>}
  </div>)
}

function handleDown({ clientX, clientY }, ifon, setIfon) {
  const domIfon = ifon.dom.current.getBoundingClientRect()
  setIfon({
    ...ifon,
    isPress: true,
    pressX: clientX,
    pressY: clientY,
    isMove: false,
    x1: clientX - domIfon.x,
    y1: clientY - domIfon.y
  })
}

function handleMove({ clientX, clientY }, ifon, setIfon) {
  setIfon({
    ...ifon,
    isMove: true,
    moveX: clientX - ifon.pressX,
    moveY: clientY - ifon.pressY,
    moveX1: clientX,
    moveY1: clientY
  })
}

function handleUp(event, ifon, setIfon) {
  setIfon({
    ...ifon,
    isPress: false,
    isMove: false,
    pressX: null,
    pressY: null,
    moveX: null,
    moveY: null
  })
}

